var map = {
	"./1类爆炸.webp": "d5f8",
	"./6类感染.webp": "82f7",
	"./7类1级.webp": "1b52",
	"./7类2级.webp": "d1cf",
	"./7类3级.webp": "8897",
	"./9类杂项.webp": "431b",
	"./9类电池.webp": "a180",
	"./Air-FranceKLM.png": "7847",
	"./Air-FranceKLM.webp": "82fb",
	"./Boli-USA.jpg": "3bb6",
	"./CAST证书_01.png": "845d",
	"./CAST证书_01.webp": "b373",
	"./CNAS.png": "9cce",
	"./CNAS.webp": "a2e2",
	"./Etihad-Airways.png": "5db3",
	"./GSP.png": "3be4",
	"./GSP.webp": "520a8",
	"./Haier.jpg": "c68a",
	"./IATA北京2026_01.png": "4ae3",
	"./IATA北京2026_01.webp": "ae9f",
	"./LH.jpg": "7602",
	"./Poland.jpg": "66ef",
	"./RLP.jpg": "204e",
	"./Russia.jpg": "6816",
	"./Russia.webp": "74e6",
	"./Singapore.jpg": "46ce",
	"./South-Korea.jpg": "f221",
	"./Swiss-Air.png": "2100",
	"./Swiss-Air.webp": "3e94",
	"./Turkey.jpg": "c400",
	"./air-china.jpg": "16b4",
	"./air-china.webp": "439f",
	"./b3.png": "cb30",
	"./b3.webp": "1178",
	"./bp.jpg": "b1d8",
	"./british-Airways.png": "68af",
	"./british-Airways.webp": "4268",
	"./cdj.png": "c1f3",
	"./cdj.webp": "af79",
	"./cdkf1.jpg": "a323",
	"./cdkf2.jpg": "f041",
	"./cdkf2.webp": "8184",
	"./china-eastern.png": "c07f",
	"./china-map.png": "dd25",
	"./china-map.webp": "8e7f",
	"./china-southern.jpg": "5a7c",
	"./china-southern.webp": "07f8",
	"./class1.png": "238d",
	"./class1.webp": "1d12",
	"./class2.png": "20b4",
	"./class2.webp": "5910",
	"./class3.png": "2106",
	"./class3.webp": "1a3d",
	"./class4.png": "609b",
	"./class4.webp": "0005",
	"./class5.png": "bd97",
	"./class5.webp": "3c04",
	"./class6.png": "6c25",
	"./class6.webp": "a669",
	"./class7.png": "2837",
	"./class7.webp": "be18",
	"./class8.png": "c2b4",
	"./class8.webp": "fe60",
	"./class9.png": "3351",
	"./class9.webp": "d113",
	"./cmacgm.png": "8f1c",
	"./cmacgm.webp": "4d2d",
	"./cosco.png": "5edd",
	"./dd.png": "f1dd",
	"./dd.webp": "6afb",
	"./demo-01-slide-2.jpg": "f737",
	"./demo-01-slide-3.jpg": "4dc0",
	"./demo-02-slide1.jpg": "45e0",
	"./dgm.png": "3853",
	"./dgm.webp": "9a37",
	"./dingzhi.png": "9703",
	"./dingzhi.webp": "e0c6",
	"./dz.jpg": "030a",
	"./dz.webp": "232b",
	"./ek.jpg": "b888",
	"./ek.webp": "3265",
	"./evergreen.png": "50ff",
	"./fst4fa53ebf.png": "c168",
	"./fst4fa53ebf.webp": "e1ef",
	"./gd.jpg": "0901",
	"./gd.webp": "74ca",
	"./guotai.jpeg": "acdb",
	"./guotai.webp": "2cf1",
	"./gz3.jpg": "567e",
	"./gzbgs.jpg": "12df",
	"./gzh.jpg": "6d9e",
	"./gzh.webp": "17d1",
	"./hg.jpg": "e2b0",
	"./hg.webp": "be70",
	"./hnhk.jpeg": "a40f",
	"./hnhk.webp": "feee",
	"./iata.png": "914f",
	"./iata.webp": "de28",
	"./iata1.png": "bf44",
	"./iata1.webp": "d949",
	"./iatalogo.png": "3171",
	"./iatalogo.webp": "f128",
	"./jc1.png": "b908",
	"./jc1.webp": "cd23",
	"./jc2.jpg": "3407",
	"./jdb.png": "9be7",
	"./jdb.webp": "a65c",
	"./jiandingbao.jpg": "34d8",
	"./jiandingbao.webp": "05f0",
	"./jnd.jpg": "e486",
	"./jnd.webp": "13e2",
	"./ll.png": "221c",
	"./ll.webp": "d808",
	"./logo.png": "9d64",
	"./logo.webp": "fcb5",
	"./logo_wcaworld1.png": "47e2",
	"./logo_wcaworld1.webp": "0ed3",
	"./logo_wcaworld2.png": "50c5",
	"./logo_wcaworld2.webp": "38f6",
	"./maersk.png": "20e1",
	"./maersk.webp": "3a20",
	"./mhes.png": "2e49",
	"./miandian.jpg": "fce4",
	"./miandian.webp": "07d0",
	"./msc.png": "9efa",
	"./msc.webp": "d794",
	"./one.png": "04fb",
	"./one.webp": "ece2",
	"./oocl.jpg": "4214",
	"./ouboli.png": "d483",
	"./ouboli.webp": "3113",
	"./pmx.jpg": "af49",
	"./qatar.jpg": "1145",
	"./qatar.webp": "fc25",
	"./rknT2.jpeg": "4481",
	"./rknT2.webp": "bd52",
	"./shape_11.png": "90dd",
	"./shhg.png": "6b2e",
	"./shhy.jpg": "5b5d",
	"./shky.png": "13d8",
	"./shlk.jpg": "deec",
	"./sichuan-air.png": "b3b7",
	"./sjk.webp": "6575",
	"./sjk1.png": "ff08",
	"./sjk1.webp": "234f",
	"./slk.jpg": "e6cb",
	"./thai.jpg": "89a0",
	"./thai.webp": "0321",
	"./tjjj.jpg": "05c6",
	"./tjjj.webp": "ad0a",
	"./tmlogo.png": "74f3",
	"./tmlogo.webp": "71f1",
	"./united.png": "1b7c",
	"./united.webp": "db6c",
	"./usa.png": "43e9",
	"./wanhai.png": "39c5",
	"./wanhai.webp": "29cd",
	"./wxp.png": "1f08",
	"./wxp.webp": "588d",
	"./xiaochengxu.jpg": "cd5c",
	"./xiaochengxu.webp": "dcd5",
	"./xn.jpg": "8f8b",
	"./xn.webp": "0402",
	"./yml.png": "311b",
	"./yy.png": "f074",
	"./yy.webp": "ad72",
	"./zjwm.png": "02f3",
	"./zjwm.webp": "4383",
	"./上海办公室.jpg": "b938",
	"./上海变频冷库.jpg": "7f09",
	"./仅限货机.jpg": "f87c",
	"./例外包装件(放射).jpg": "6328",
	"./冷库温度显示装置检定报告_01.png": "3df0",
	"./冷库温度显示装置检定报告_01.webp": "88a2",
	"./北京冷库1.jpg": "cddd",
	"./北京冷库2.jpg": "a42c",
	"./北京办公室.jpg": "1162",
	"./北京办公室2.jpg": "6b66",
	"./北京库房.jpg": "2ea1",
	"./医药WCA_01.png": "1028",
	"./医药WCA_01.webp": "20e2",
	"./危品WCA_01.png": "a504",
	"./危品WCA_01.webp": "5389",
	"./向上签.jpg": "964f",
	"./对健康有危害.jpg": "42e1",
	"./广州仓库2.jpg": "0cc1",
	"./广州冷库2.jpg": "6ca4",
	"./广州办公室 (2).jpg": "a9c0",
	"./广州办公室.jpg": "fcc8",
	"./广州办公室1.jpg": "99d8",
	"./成都办公室1.png": "f60f",
	"./成都办公室1.webp": "d538",
	"./有害.jpg": "9288",
	"./有限数量.jpg": "28d9",
	"./泛思特海运办公室(1).jpg": "6c0f",
	"./泛思特营业执照-正本.jpg": "a9e6",
	"./混动.jpeg": "cddb",
	"./混动.png": "2537",
	"./背景1.jpg": "e628",
	"./航协会员证书_01.png": "c608",
	"./航协会员证书_01.webp": "2f9e",
	"./质量管理体系_01.png": "4092",
	"./质量管理体系_01.webp": "ade3",
	"./远离热源.jpg": "c3d4",
	"./郑州办公室.jpg": "e1f8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";